import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import type { RouteObject } from "react-router-dom";

import { PartnerDetailPage } from "./partner-detail-page";
import { PartnersPage } from "./partners-page";

const partnerDetailBreadcrumb = breadcrumbSlot();

export const partnersRoutes: RouteObject[] = [
  {
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        handle: { breadcrumb: "Partners" },
        element: <PartnersPage />,
      },
      {
        path: ":partnerId",
        handle: { breadcrumb: "Partner" },
        children: [
          {
            index: true,
            handle: { breadcrumb: partnerDetailBreadcrumb },
            element: <PartnerDetailPage breadcrumb={partnerDetailBreadcrumb} />,
          },
        ],
      },
    ],
  },
];
